import React, {useContext, useEffect, useState} from 'react';
import { Auth } from "aws-amplify";
import UserContext from '../UserContext';
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import {navigate, Link} from '@reach/router';
import {Colors, Callout} from 'react-foundation';

export default props => {
  const [cogeoUser, setCogeoUser] = useState(null);
  const {user, setUser} = useContext(UserContext);
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [formState, setFormState] = useState('login');
  const [messages, setMessages] = useState(false);

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  const updatePassword = async () => {
    if (!password) {
      setErrors('Password cannot be empty');
      return;
    }

    try {
      const loggedInUser = await Auth.completeNewPassword(
        cogeoUser, // the Cognito User Object
        password // the new password
      )
  
      console.log(loggedInUser);
      setUser(loggedInUser.username)
    } catch(err) {
      setErrors(err.message);
      return;
    }
  }

  const handleLogin = async () => {
    if (!password) {
      setErrors('Password cannot be empty');
      return;
    }

    try {
      const user = await Auth.signIn(emailAddress, password);
      setCogeoUser(user)

      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
        setPassword('')
        setMessages("Password must be updated. Please enter a new password:")
        setFormState('update-password')
      } 
      else {
        setUser(user.username)
      }

      console.log(user)
    } catch (e) {
      setErrors(e.message)
    }
  };

  const resetEmail = async () => {
    if (!emailAddress) {
      setErrors('Email address is required to reset your password');
      return;
    }
    try {
      await Auth.forgotPassword(emailAddress);
      setMessages('A verification code has been sent to your email address');
      setFormState('reset-password');
    } catch (e) {
      setErrors(e.message)
    }
  };

  const handlePasswordReset = async () => {
    try {
      await Auth.forgotPasswordSubmit(emailAddress, confirmationCode, password)
      setMessages('Password successfully reset');
      setFormState('login')
    } catch (e) {
      setErrors(e.message);
    } 
  }

  const updatePasswordForm = (
  <Grid.Column style={{ maxWidth: 450 }}>
    <Header as='h2' color='teal' textAlign='center'>
      <Image src='/assets/images/logos/sayers-logo-small.jpg' /> Log-in to your account
    </Header>
    {messages && <Callout color={Colors.SUCCESS}>{messages}</Callout>}
    {errors && <Callout color={Colors.ALERT}>{errors}</Callout>}
    <Form size='large'>
      <Segment stacked>
        <Form.Input
          fluid
          icon='user'
          iconPosition='left'
          placeholder='E-mail address'
          value={emailAddress}
          onChange={(evt, selector) => setEmailAddress(selector.value)}
        />
        <Form.Input
          fluid
          icon='lock'
          iconPosition='left'
          placeholder='Password'
          type='password'
          value={password}
          onChange={(evt, selector) => setPassword(selector.value)}
        />

        <Button color='teal' fluid size='large' onClick={() => updatePassword()}>
          Update password
        </Button>
      </Segment>
    </Form>
  </Grid.Column>);

  const loginForm = (<Grid.Column style={{ maxWidth: 450 }}>
    <Header as='h2' color='teal' textAlign='center'>
      <Image src='/assets/images/logos/sayers-logo-small.jpg' /> Log-in to your account
    </Header>
    {messages && <Callout color={Colors.SUCCESS}>{messages}</Callout>}
    {errors && <Callout color={Colors.ALERT}>{errors}</Callout>}
    <Form size='large'>
      <Segment stacked>
        <Form.Input
          fluid
          icon='user'
          iconPosition='left'
          placeholder='E-mail address'
          value={emailAddress}
          onChange={(evt, selector) => setEmailAddress(selector.value)}
        />
        <Form.Input
          fluid
          icon='lock'
          iconPosition='left'
          placeholder='Password'
          type='password'
          value={password}
          onChange={(evt, selector) => setPassword(selector.value)}
        />

        <Button color='teal' fluid size='large' onClick={() => handleLogin()}>
          Login
        </Button>
      </Segment>
    </Form>
    <Message>
      New to us? <Link to='/register'>Sign Up.</Link> <br />
      Forgot password? <a href="#" onClick={resetEmail}>Reset it</a>
    </Message>
  </Grid.Column>);

  const resetPasswordForm = (
    <Grid.Column style={{ maxWidth: 450 }}>
      {messages && <Callout color={Colors.SUCCESS}>{messages}</Callout>}
      {errors && <Callout color={Colors.ALERT}>{errors}</Callout>}
      <Form size='large'>
        <Segment stacked>
          <Form.Input
            fluid
            icon='user'
            iconPosition='left'
            placeholder='E-mail address'
            value={emailAddress}
            onChange={(evt, selector) => setEmailAddress(selector.value)}
          />
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='New password'
            type='password'
            value={password}
            onChange={(evt, selector) => setPassword(selector.value)}
          />
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Conformation code'
            type='text'
            value={confirmationCode}
            onChange={(evt, selector) => setConfirmationCode(selector.value)}
          />
          <Button color='teal' fluid size='large' onClick={() => handlePasswordReset()}>
            Reset password
          </Button>
        </Segment>
      </Form>
    </Grid.Column>
  )

  return (
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      {  formState === 'update-password' ? updatePasswordForm :
       formState === 'reset-password' ? resetPasswordForm :
        loginForm }
    </Grid>
  );
};